// Ventas de canal externo (Tienda Nube, Mercado Libre, Rappi, PedidosYa).
//
// Estas ventas ya fueron cobradas y contabilizadas por crear_venta_canal: la
// plata entra al banco del medio de cobro del canal y la venta queda con
// afecta_caja = false. Ningún otro circuito (pedidos web, devoluciones) puede
// volver a tocar caja, banco o cuenta corriente por esta venta.
//
// Puro, sin imports de supabase. Ver docs/specs/tienda-nube-codigo-sonnet.md,
// tarea S1.

const CANALES_POR_CHANNEL = {
  tiendanube: "Tienda Nube",
  mercadolibre: "Mercado Libre",
  rappi: "Rappi",
  pedidosya: "PedidosYa",
};

const CANALES_POR_BILLING_SOURCE = {
  tienda_nube: "Tienda Nube",
  mercado_libre: "Mercado Libre",
  rappi: "Rappi",
  pedidosya: "PedidosYa",
};

function normalizar(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");
}

function normalizarBillingSource(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
}

export function esVentaDeCanalExterno(sale) {
  if (!sale) return false;

  const channel = normalizar(sale.channel);
  if (channel && CANALES_POR_CHANNEL[channel]) return true;

  const billingSource = normalizarBillingSource(sale.billing_source);
  if (billingSource && CANALES_POR_BILLING_SOURCE[billingSource]) return true;

  return false;
}

export function etiquetaCanal(sale) {
  if (!sale) return null;

  const channel = normalizar(sale.channel);
  if (channel && CANALES_POR_CHANNEL[channel]) return CANALES_POR_CHANNEL[channel];

  const billingSource = normalizarBillingSource(sale.billing_source);
  if (billingSource && CANALES_POR_BILLING_SOURCE[billingSource]) {
    return CANALES_POR_BILLING_SOURCE[billingSource];
  }

  return null;
}

export function motivoVentaFueraDeCaja(sale) {
  if (!sale || sale.afecta_caja !== false) return null;

  const canal = etiquetaCanal(sale);
  if (canal) {
    return `Venta de ${canal}: se cobró por el canal (${sale.payment_method}). El reintegro no toca el arqueo.`;
  }

  return `Venta administrativa: no pasó por caja (${sale.payment_method || "cuenta corriente"}). El reintegro tampoco toca el arqueo.`;
}
